"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const mutation = (0, client_1.gql) `
  mutation acceptRole($roleId: String!, $accept: Boolean!) {
    acceptRole(roleId: $roleId, accept: $accept) {
      _id
      userId
      userEmail
      token
      orgId
      role
      acceptedAt
    }
  }
`;
exports.default = mutation;
//# sourceMappingURL=acceptRole.mutation.js.map